module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cktDT"))).then(() => parcelRequire('d0iPb'));